import { TooltipComponent } from './tooltip.component';
import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
} from '@angular/core';

@Directive({
  selector: '[tooltip]',
})
export class TooltipDirective {
  @Input() tooltip: string | undefined = '';
  @Input() tooltipDisabled: boolean = false;
  @Input() tooltipPosition: 'top' | 'bottom' = 'bottom';

  private componentRef: ComponentRef<any> | null = null;

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipDisabled || this.tooltip === undefined) {
      return;
    }

    if (this.componentRef === null) {
      const componentFactory =
        this.componentFactoryResolver.resolveComponentFactory(TooltipComponent);
      this.componentRef = componentFactory.create(this.injector);
      this.appRef.attachView(this.componentRef.hostView);
      const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;
      document.body.appendChild(domElem);
      this.setTooltipComponentProperties();
    }
  }
  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  constructor(
    private elementRef: ElementRef,
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
  ) {}

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    if (this.componentRef !== null) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  private setTooltipComponentProperties() {
    if (this.componentRef !== null) {
      this.componentRef.instance.tooltip = this.tooltip;
      this.componentRef.instance.position = this.tooltipPosition;
      const { left, right, top, bottom } = this.elementRef.nativeElement.getBoundingClientRect();
      this.componentRef.instance.left = (right - left) / 2 + left;
      if (this.tooltipPosition === 'top') {
        // Позиционируем сверху: используем top элемента, а translateY(-100%) в CSS переместит тултип вверх
        this.componentRef.instance.top = top;
      } else {
        this.componentRef.instance.top = bottom;
      }
    }
  }
}
